<div class="message message-warning" data-testid="<%= testIds.booking.error %>">
  <%- error_messages.ehr_appointment_slot_id_slot_expired %>
</div>
